module.exports = __webpack_public_path__ + "static/media/mc_1200.fcaba5ba.png";